import { EditFilled, EyeFilled, UserOutlined } from '@ant-design/icons';
import { EnumPersonaFisicaRequestDTORuolo } from '@framework/api-client/api/backoffice/schemas/enumPersonaFisicaRequestDTORuolo.ts';
import { assertNever } from '@framework/engine/utils/assertNever.ts';
import { t } from '@framework/i18n/intl/i18next.ts';
import { Tag, type TagProps } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';

const StyledRoleTag = styled(Tag)`
  text-transform: uppercase;
  .anticon {
    vertical-align: -0.175em;
    margin-right: 4px;
  }
`;

/**
 * Ritorna le impostazioni per il tag
 */
function getTagOptions(role: EnumPersonaFisicaRequestDTORuolo): TagProps {
  if (!role) return {};
  switch (role) {
    case EnumPersonaFisicaRequestDTORuolo.EDITOR:
      return {
        color: 'green-inverse',
        children: (
          <>
            <EditFilled aria-hidden="true" />
            {t('dossier-permission.ruolo.editor', 'Intermediario')}
          </>
        ),
      };
    case EnumPersonaFisicaRequestDTORuolo.TITOLARE:
      return {
        color: 'blue-inverse',
        children: (
          <>
            <UserOutlined aria-hidden="true" />
            {t('dossier-permission.ruolo.titolare', 'Titolare')}
          </>
        ),
      };
    case EnumPersonaFisicaRequestDTORuolo.VIEWER:
      return {
        color: 'magenta-inverse',
        children: (
          <>
            <EyeFilled aria-hidden="true" />
            {t('dossier-permission.ruolo.viewer', 'Visualizzatore')}
          </>
        ),
      };
  }
  assertNever(role);
  return { children: role };
}

interface IDossierPermissionRoleTagProps {
  role: EnumPersonaFisicaRequestDTORuolo;
}

/**
 * Tag colorati per i ruoli dei soggetti
 */
export function DossierPermissionRoleTag(
  props: IDossierPermissionRoleTagProps,
) {
  const { role } = props;

  const label = useMemo(() => {
    return getTagOptions(role);
  }, [role]);

  return <StyledRoleTag {...label} />;
}
